import Login from '@/views/Login'

export default [
  {
    path: '/',
    name: 'login',
    component: Login
  }
]
